import {get, includes, map, set} from 'lodash';

const preferencesConfig = {
    formData: {
        whitelist: ['shelfItems', 'users'],
        authReset: [],
        paths: ['operators', 'values'],
    },
    layout: true,
    searchForm: true,
    servicesSearchData: {
        whitelist: ['shelfItems', 'shelfItemsDetail', 'users'],
        authReset: [],
        paths: ['query.sort', 'query.page', 'query.pageLimit', 'query.exactMatch'],
    },
};

export function applyPreferenceState(preferenceKey, preferenceState, state, whitelistKey) {
    if (preferenceState && includes(get(preferencesConfig, [preferenceKey, 'whitelist'], []), whitelistKey)) {
        map(get(preferencesConfig, [preferenceKey, 'paths']), path => {
            const value = get(preferenceState, path);

            if (value) {
                set(state, path, value);
            }
        });
    }

    return state;
}

export default preferencesConfig;
